import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
        },
        {
            // 正式听课
            path: '/courseware-player',
            name: 'courseware-player',
            component: () => import('./subpage/courseware-player/courseware-player.vue'),
        },
        {
            // 正式听课 new
            path: '/student-learn',
            name: 'student-learn',
            component: () => import('./subpage/courseware-player/student-learn.vue'),
        },
        {
            // 慕课正式听课
            path: '/courseware-mooc-player',
            name: 'courseware-mooc-player',
            component: () => import('./subpage/courseware-player/courseware-mooc-player.vue'),
        },
        {
            // 慕课正式听课
            path: '/student-mooc-learn',
            name: 'student-mooc-learn',
            component: () => import('./subpage/courseware-player/student-mooc-learn.vue'),
        },
        {
            // 慕课正式听课 对接监管平台
            path: '/courseware-mooc-charge',
            name: 'courseware-mooc-charge',
            component: () => import('./subpage/courseware-player/courseware-mooc-charge.vue'),
        },
        {
            path: '/player-error/:error',
            name: 'player-error',
            component: () => import('./subpage/courseware-player/player-error.vue'),
        },
        {
            // 免费试听
            path: '/courseware-free',
            name: 'courseware-free',
            component: () => import('./subpage/courseware-player/courseware-free.vue'),
        },
        {
            // 学生免费试听
            path: '/student-free-learn',
            name: 'student-free-learn',
            component: () => import('./subpage/courseware-player/student-free-learn.vue'),
        },
    ]
});
